import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TRACKING } from '../../enums/trackingParts.enum';
import { TrackingService } from '../../services/tracking.service';
import { ReBaseData } from '../../../shared/utils/re-base-data';

@Component({
    selector: 'bdo-contract-cancel-status',
    templateUrl: './contract-cancel-status.component.html',
    styleUrls: ['./contract-cancel-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContractCancelStatusComponent implements OnInit {
  public TRACKING = TRACKING;
  protected reBaseData = ReBaseData;

  constructor(
    private trackingService: TrackingService
  ) { }

  ngOnInit(): void {
    this.trackingService.postTracking(TRACKING.LOCATION.CONTRACT_CANCEL_STATUS, TRACKING.ACTION.ENTER);
  }



}
